// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"7f2d7a72","229":"7d9b5c70","313":"47253502","453":"54292a4b","550":"cda035b9","562":"1aa1f7f3","798":"4fb5d2ea","918":"bd668959","962":"d611ea40","984":"b655a340"}[chunkId] + ".chunk.js";
};